import React, { useState } from "react";
// HashRouter (not BrowserRouter) because GitHub Pages has no server-side rewrite
// support — client-side routes need to live after the "#" to survive a page refresh.
import { HashRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./components/AdminDashboard";

// Guest Pages
import HomePage from "./pages/HomePage";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";

// Admin Pages
import AdminLogin from "./pages/AdminLogin";
import AdminOrders from "./pages/AdminOrders";

// Shared / Exception Pages
import NotFoundException from "./exceptions/NotFoundException";

function App() {
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = sessionStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const persistCart = (updatedCart) => {
    setCartItems(updatedCart);
    sessionStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const handleAddToOrder = (product, quantity) => {
    const existing = cartItems.find((item) => item.id === product.id);
    let updatedCart;
    if (existing) {
      updatedCart = cartItems.map((item) =>
        item.id === product.id
          ? { ...item, quantity: item.quantity + quantity }
          : item
      );
    } else {
      updatedCart = [...cartItems, { ...product, quantity }];
    }
    persistCart(updatedCart);
  };

  const handleUpdateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      handleRemoveFromOrder(productId);
      return;
    }
    persistCart(
      cartItems.map((item) =>
        item.id === productId ? { ...item, quantity } : item
      )
    );
  };

  const handleRemoveFromOrder = (productId) => {
    persistCart(cartItems.filter((item) => item.id !== productId));
  };

  const handleClearOrder = () => {
    persistCart([]);
  };

  return (
    <Router>
      <div className="app-shell">
        <Navbar />
        <main className="app-main">
          <Routes>
            {/* Guest Routes */}
            <Route path="/" element={<HomePage onAddToOrder={handleAddToOrder} />} />
            <Route
              path="/products"
              element={<Products onAddToOrder={handleAddToOrder} />}
            />
            <Route
              path="/products/:id"
              element={<ProductDetails onAddToOrder={handleAddToOrder} />}
            />
            <Route
              path="/cart"
              element={
                <CartPage
                  cartItems={cartItems}
                  onUpdateQuantity={handleUpdateQuantity}
                  onRemoveItem={handleRemoveFromOrder}
                />
              }
            />
            <Route
              path="/checkout"
              element={
                <CheckoutPage cartItems={cartItems} onOrderComplete={handleClearOrder} />
              }
            />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/orders"
              element={
                <ProtectedRoute>
                  <AdminOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/products"
              element={
                <ProtectedRoute>
                  <Products />
                </ProtectedRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<NotFoundException />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
